// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { getQueryByConfig, QueryRegistryFactory } from '../../../contexts'
import { CUSTOMER_ORDERS_FRAGMENTS_MAP } from './graphql/fragments'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const orderQueries: QueryRegistryFactory = (config) => {
  const CUSTOMER_ORDERS_FRAGMENT = getQueryByConfig(config, CUSTOMER_ORDERS_FRAGMENTS_MAP)

  return ({
    ordersQuery: {
      type: 'query',
      query: gql`
        ${CUSTOMER_ORDERS_FRAGMENT}
        query customer($currentPage: Int!, $pageSize: Int!) {
          customer {
            orders(currentPage: $currentPage, pageSize: $pageSize, sort: { created_at: DESC }) {
              ...CustomerOrdersFragment
            }
          }
        }
      `,
      meta: {
        noAuth: false
      }
    },

    singleOrder: {
      type: 'query',
      query: gql`
        ${CUSTOMER_ORDERS_FRAGMENT}
        query customer($order: String!) {
          customer {
              orders(filter: { number: { eq: $order } }, sort: { created_at: DESC } ) {
                  ...CustomerOrdersFragment
              }
          }
        }
      `,
      meta: {
        noAuth: false
      }
    },

    retryPaymentUrl: {
      type: 'mutation',
      query: gql`
          mutation($order_id: String!) {
              retryPaymentUrl (order_id: $order_id) {
                  url
              }
          }
      `,
      meta: {
        noAuth: false
      }
    }
  })
}
